class ZendeskTable extends HTMLElement {
  connectedCallback() {
    this.documentId = this.dataset.documentId

    if (this.documentId) {
      this.loadArticles(this.documentId)
    } else {
      this.bindToggles()
    }
  }

  bindToggles() {
    this.querySelectorAll('.zendesk-table-item').forEach((item) => {
      const summary = item.querySelector('summary')
      if (!summary) return
      summary.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleItem(item)
      })
    })
  }

  toggleItem(target) {
    this.querySelectorAll('.zendesk-table-item[open]').forEach((item) => {
      if (item !== target) this.animateClose(item)
    })
    target.open ? this.animateClose(target) : this.animateOpen(target)
  }

  animateOpen(item) {
    const body = item.querySelector('.zendesk-table-body')
    if (!body) return
    item.open = true
    body.animate(
      [
        { height: '0px', opacity: 0 },
        { height: body.scrollHeight + 'px', opacity: 1 },
      ],
      { duration: 300, easing: 'ease' },
    )
  }

  animateClose(item) {
    const body = item.querySelector('.zendesk-table-body')
    if (!body) return
    const anim = body.animate(
      [
        { height: body.offsetHeight + 'px', opacity: 1 },
        { height: '0px', opacity: 0 },
      ],
      { duration: 250, easing: 'ease', fill: 'forwards' },
    )
    anim.onfinish = () => {
      item.open = false
      anim.cancel()
    }
  }

  async loadArticles(documentId) {
    const container = this.querySelector('.zendesk-table-items')
    if (!container) return

    try {
      const res = await fetch(
        `/apps/api/articles?section_id=${encodeURIComponent(documentId)}`
      )
      if (!res.ok) throw new Error(`${res.status}`)

      const articles = await res.json()

      if (!Array.isArray(articles) || !articles.length) {
        container.innerHTML =
          '<p class="zendesk-table-empty">No FAQ articles found.</p>'
        return
      }

      container.innerHTML = articles.map((a) => this.rowMarkup(a)).join('')
      this.bindToggles()
    } catch (err) {
      console.error('Failed to load Zendesk articles:', err)
      container.innerHTML =
        '<p class="zendesk-table-error">Unable to load FAQ content.</p>'
    }
  }

  rowMarkup(article) {
    const title = this.escapeHtml(article.title || '')
    const body = article.body || ''
    return `
      <details class="zendesk-table-item" role="listitem">
        <summary class="zendesk-table-header">
          <span class="zendesk-table-question">${title}</span>
          <span class="zendesk-table-icon" aria-hidden="true"></span>
        </summary>
        <div class="zendesk-table-body">
          <div class="zendesk-table-answer">${body}</div>
        </div>
      </details>`
  }

  escapeHtml(str) {
    const el = document.createElement('span')
    el.textContent = str
    return el.innerHTML
  }
}

customElements.define('zendesk-table', ZendeskTable)
